// extracted by mini-css-extract-plugin
export default {"gridProductsResults":"GridResults_gridProductsResults__b6AMM"};